<template>
  <div class="account-layout">
    <v-app-bar app flat color="white" class="account-top-bar">
      <v-btn icon class="back-button" aria-label="Back to smplsale" @click="$router.push('/')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <div class="toolbar-brand">
        <div class="toolbar-icon"><v-icon color="primary">mdi-shield-check-outline</v-icon></div>
        <div>
          <div class="toolbar-title">Account &amp; Billing</div>
          <div class="toolbar-subtitle">Secure subscription management</div>
        </div>
      </div>

      <v-spacer />

      <div v-if="currentBusiness" class="location-badge">
        <div class="location-label">LOCATION</div>
        <div class="location-code">{{ currentBusiness.code }}</div>
      </div>

      <v-btn text rounded small color="grey darken-2" class="home-action" @click="$router.push('/')">
        <v-icon left small>mdi-view-dashboard-outline</v-icon>
        Back to app
      </v-btn>
    </v-app-bar>

    <v-main class="account-main">
      <v-container fluid class="account-content">
        <router-view></router-view>
      </v-container>
    </v-main>
  </div>
</template>
 
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "account",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
  },
  async created() {
    await this.initUser();
  },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
  },
};
</script>

<style scoped>
.account-layout{min-height:100%;background:#f8fafc}.account-top-bar{border-bottom:1px solid #e2e8f0!important}.back-button{margin-right:8px;background:#f8fafc}.toolbar-brand{display:flex;align-items:center}.toolbar-icon{width:38px;height:38px;border-radius:12px;background:#eef4ff;display:flex;align-items:center;justify-content:center;margin-right:11px}.toolbar-title{font-size:15px;font-weight:800;color:#0f172a;line-height:1.2}.toolbar-subtitle{font-size:10px;color:#64748b;margin-top:2px}.location-badge{padding:7px 12px;border-radius:12px;background:#f8fafc;border:1px solid #e2e8f0;margin-right:10px;min-width:90px}.location-label{font-size:8px;font-weight:800;letter-spacing:.12em;color:#94a3b8}.location-code{font-size:13px;font-weight:800;color:#334155;line-height:1.2}.account-main{background:#f8fafc}.account-content{padding:20px!important}@media(max-width:600px){.toolbar-subtitle,.home-action{display:none}.toolbar-icon{display:none}.toolbar-title{font-size:14px}.location-badge{margin-right:0;min-width:auto;padding:6px 9px}.account-content{padding:10px!important}}
</style>
